import { Avatar, Box, Button, Paper, TextField, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { U_Signup } from "../apis/Endpoint"; // This should match your backend URL
import { useState } from "react";
import axios from "axios";

const Signup = () => {
  const navigate = useNavigate();
  const [auth, setAuth] = useState({
    name: "",
    email: "",
    password: "",
    confirmPassword: ""
  });

  const handleChange = (event) => {
    const { value, name } = event.target;
    setAuth({ ...auth, [name]: value });
  };

  const handleSignup = () => {
    if (auth.password === auth.confirmPassword) {

      axios.post(U_Signup, auth)  // Correct endpoint URL for backend
        .then((res) => {
          if (res.data.message === "User registered successfully") {
            navigate("/login");
          } else {
            alert(res.data.message); // Alert if there's an error
          }
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      alert("Passwords do not match");
    }
  };

  return (
    <Box sx={{
      width: "100%",
      height: "100vh",
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    }}>
      <Paper elevation={3} sx={{
        width: "25%",
        height: "75vh",
        padding: 2,
        gap: 3,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        border: "2px solid #7b1fa2",  // Purple border
      }}>
        <Avatar sx={{ bgcolor: "#7b1fa2" }} src="/broken-image.jpg" />

        <Typography variant="h5" gutterBottom>SIGNUP</Typography>

        <TextField
          label="Username"
          variant="outlined"
          fullWidth
          name="name"
          onChange={handleChange}
          sx={{
            "& label.Mui-focused": {
              color: "#7b1fa2",
            },
            "& .MuiOutlinedInput-root": {
              "& fieldset": {
                borderColor: "grey",
              },
              "&:hover fieldset": {
                borderColor: "#7b1fa2",
              },
              "&.Mui-focused fieldset": {
                borderColor: "#7b1fa2",
              },
            },
          }}
        />

        <TextField
          label="Email"
          variant="outlined"
          fullWidth
          name="email"
          onChange={handleChange}
          sx={{
            "& label.Mui-focused": {
              color: "#7b1fa2",
            },
            "& .MuiOutlinedInput-root": {
              "& fieldset": {
                borderColor: "grey",
              },
              "&:hover fieldset": {
                borderColor: "#7b1fa2",
              },
              "&.Mui-focused fieldset": {
                borderColor: "#7b1fa2",
              },
            },
          }}
        />

        <TextField
          label="Password"
          variant="outlined"
          fullWidth
          name="password"
          onChange={handleChange}
          sx={{
            "& label.Mui-focused": {
              color: "#7b1fa2",
            },
            "& .MuiOutlinedInput-root": {
              "& fieldset": {
                borderColor: "grey",
              },
              "&:hover fieldset": {
                borderColor: "#7b1fa2",
              },
              "&.Mui-focused fieldset": {
                borderColor: "#7b1fa2",
              },
            },
          }}
        />

        <TextField
          label="Confirm Password"
          variant="outlined"
          fullWidth
          name="confirmPassword"
          onChange={handleChange}
          sx={{
            "& label.Mui-focused": {
              color: "#7b1fa2",
            },
            "& .MuiOutlinedInput-root": {
              "& fieldset": {
                borderColor: "grey",
              },
              "&:hover fieldset": {
                borderColor: "#7b1fa2",
              },
              "&.Mui-focused fieldset": {
                borderColor: "#7b1fa2",
              },
            },
          }}
        />

        <Button
          variant="contained"
          onClick={handleSignup}
          sx={{
            backgroundColor: "#7b1fa2",
            "&:hover": {
              backgroundColor: "#6a1b9a"
            }
          }}
        >
          SIGNUP
        </Button>
      </Paper>
    </Box>
  )
}

export default Signup;
